import React from "react";

import {
  Form,
  FormElement,
  FormValidator,
  CustomTextControl,
  BaseReactComponent,
  FormSubmitButton,
  SelectControl,
} from "../../utils/form";
import { Row, Col } from "react-bootstrap";
import { ClearButton, CustomModal, Spinner } from "../common";
import { addEventcategoryApi, updateEvenCategoryApi } from "./Api";
import { getAdminUser, getSafeArray, isPartnerAllowed } from "../../utils/ReusableFunctions";
import { getAllSsoPartnersApi } from "../sso/Api";
import { isModuleExist, MODULE_ID_MAP, publishOptions } from "../../utils/Constant";

class EventCategoryForm extends BaseReactComponent {
  constructor(props) {
    super(props);
    const data = props.editData || null;
    const AccesData = isModuleExist(MODULE_ID_MAP.EventMasterCategory);
    let partners = this.loadDefaultPartners(AccesData)
    if (data?.partners?.list) {
      partners = data?.partners
    }

    this.state = {
      AccessData: AccesData,
      eventCategoryName: data?.eventCategoryName || "",
      resLoading: false,
      partners,
    };
  }

  componentDidMount() {
    getAllSsoPartnersApi(this)
  }
  onValidSubmit = () => {
    this.setState({ resLoading: true })
    let data = {
      "data": {
        "eventCategoryName": this.state.eventCategoryName,
        "partners": this.state.partners,
      },
    };
    if(!isPartnerAllowed(this.state.AccessData?.id)){
      delete data.data.partners;
    }

    if (this.props?.editData?.uuid) {
      updateEvenCategoryApi(data, this.props.this, this.props.onHide, this.props.editData.uuid, this)
    } else {
      addEventcategoryApi(JSON.stringify(data), this.props.this, this.props.onHide, this);
    }
  };
  render() {
    return (
      <CustomModal
        show={this.props.show}
        onHide={this.props.onHide}
        title={(this.props?.editData?.uuid) ? "Edit Event Category" : "Add Event Category"}
        modalClass={"change-password"}
      >
        <Form onValidSubmit={this.onValidSubmit}>
          <Row>
                        {isPartnerAllowed(this.state.AccessData?.id) && 

            <Col md={6}>
              <FormElement
                valueLink={this.linkState(this, "partners.list")}
                label="Publish To Partner(s)"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Publish To cannot be empty",
                  },
                ]}
                control={{
                  type: SelectControl,
                  settings: {
                    options: this.state?.ssoPartnersOptions || [],
                    placeholder: "Select Partner(s)",
                    multiple: true,
                    searchable: true,
                    selectAll: true,
                    onChangeCallback: (onBlur) => {
                    },
                  },
                }}
              />

            </Col>}
            <Col sm={12}>
              <FormElement
                valueLink={this.linkState(this, "eventCategoryName")}
                label="Name"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    //   type: "",
                    placeholder: "Enter Name",
                  },
                }}
              />
            </Col>
          </Row>
          <div className="submit-wrapper" style={{ justifyContent: "center" }}>
            <FormSubmitButton customClass={"primary-btn"}>
              {this.state.resLoading ? <span className="d-flex align-items-center gap-12"> <Spinner /> Saving...</span> : "Save"}
            </FormSubmitButton>
          </div>
        </Form>
      </CustomModal>
    );
  }
}

export default EventCategoryForm;
